import { User } from "../../mp-database"
import { FiltersState } from "../states"

// Constants
export const ACT_ADMIN_ALL_DISTRICTS = "ACT_ADMIN_ALL"

/**
 * Get the effective district ID for queries
 * Resolves district from entityId, filters, user's default, or ACT Admin placeholder
 */
export function getEffectiveDistrictId(
  filters: FiltersState | undefined,
  user: User | undefined,
  entityId?: string
): string {
  return (
    entityId ||
    filters?.district?.[0] ||
    user?.schoolDistrict ||
    (user?.role === "ACT Admin" ? ACT_ADMIN_ALL_DISTRICTS : "") ||
    ""
  )
}

/**
 * Build property filters for organization queries
 * Handles both district and school filters appropriately
 */
export function buildOrgPropertyFilters(
  filters: FiltersState | undefined,
  districtId: string
): Array<{ name: string; values: string[] }> {
  const propertyFilters = []

  // Handle district filters
  if (filters?.district && filters.district.length > 0) {
    propertyFilters.push({
      name: "district",
      values: filters.district
    })
  } else if (districtId && districtId !== ACT_ADMIN_ALL_DISTRICTS) {
    // Add default district if no filter is applied (but not for ACT Admin all districts)
    propertyFilters.push({
      name: "district",
      values: [districtId]
    })
  }

  // Handle school filters
  if (filters?.school && filters.school.length > 0) {
    propertyFilters.push({
      name: "school",
      values: filters.school
    })
  }

  return propertyFilters
}
